













const OPTION_LABEL = 'label'
const OPTION_KEY = 'value'

export default {
  model: { prop: 'value', event: 'select' },
  props: {
    options: {
      type: Object,
      required: true,
      validator: val => !Object.values(val).some(label => typeof label !== 'string')
    },
    value: { type: String, default: '' },
    multiple: { type: Boolean, default: false },
    sortOptions: { type: Boolean, default: true }
  },
  computed: {
    state: {
      get() {
        return this.parseValue(this.value)
      },
      set(newValue) {
        this.$emit('select', this.stringifyValues(newValue))
      }
    },
    sortedOptions() {
      const optionsList = Object.keys(this.options).map(this.getOptionObject)
      if (!this.sortOptions) {
        return optionsList
      }
      return optionsList.sort((a: any, b: any) => a.label?.localeCompare(b.label))
    }
  },
  created() {
    this.optionLabel = OPTION_LABEL
    this.optionKey = OPTION_KEY
  },
  methods: {
    parseValue(str) {
      if (!this.multiple) return this.getOptionObject(str)
      return str ? str.split(',').map(this.getOptionObject) : []
    },
    stringifyValues(arrOrObj) {
      if (!this.multiple) return arrOrObj ? this.getOptionKey(arrOrObj) : undefined
      return arrOrObj.length ? arrOrObj.map(this.getOptionKey).join(',') : undefined
    },
    getOptionObject(key) {
      return {
        [OPTION_KEY]: key,
        [OPTION_LABEL]: this.options[key]
      }
    },
    getOptionKey(object) {
      return object[OPTION_KEY]
    }
  }
}
